<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-input prefix-icon="el-icon-search" clearable v-model="filter.searchText" style="width: 260px"
                placeholder="单据编号、商品名、供应商"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">出库仓库</label>
      <warehouse-select v-model="filter.warehouse" select-all></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">出库日期</label>
      <el-date-picker
        style="width: 130px"
        v-model="filter.begDate"
        type="date"
        placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
        style="margin-left: 8px; width: 130px"
        v-model="filter.endDate"
        type="date"
        placeholder="结束日期">
      </el-date-picker>
      <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
      <el-button><a :href="exportUrl">导出</a></el-button>
    </div>
    <el-table :data="outboundList" class="table-border" v-loading="loading"
              header-cell-class-name="table-head" :max-height="tableHeight">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="单据编号" prop="code" min-width="130"></el-table-column>
      <el-table-column label="出库日期" prop="outDate"></el-table-column>
      <el-table-column label="出库仓库">
        <template #default="{row}">
          <div>{{ row.warehouseId | valueName('Warehouse') }}
            - {{ row.warehousePosId | valueName('WarehousePos') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="出库商品" prop="goodsName"></el-table-column>
      <el-table-column label="商品类型" prop="goodsType"></el-table-column>
      <el-table-column label="数量" prop="goodsNum"></el-table-column>
      <el-table-column label="金额" prop="goodsPrice"></el-table-column>
      <el-table-column label="状态">
        <template #default="{row}">
          <div>{{ row.status === 0 ? '已保存' : '已出库' }}</div>
        </template>
      </el-table-column>

      <el-table-column :width="deletable ? 150 : 160" label="操作" align="center" fixed="right">
        <template #default="{row}">
          <el-button type="text" @click="detail(row)" size="mini">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
        <template #header>
          <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteOutbound(row)" class="danger" :disabled="row.status !== 0">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import { valueName } from '@/utils/filters'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import authority from '@/utils/authority'

export default {
  name: 'OutboundList',
  mixins: [resizeCaptureMixin],
  components: { WarehouseSelect },
  data () {
    return {
      loading: false,
      filter: {
        searchText: null,
        warehouse: [null],
        begDate: null,
        endDate: null
      }
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'SUPPLIER')
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$store.dispatch('outbound/all').finally(() => {
        this.loading = false
      })
    },
    add () {
      this.$router.push({
        path: '/product/outbound_goods'
      })
    },
    detail (outbound) {
      this.$router.push({
        path: '/product/outbound_goods',
        query: { outboundId: outbound.id }
      })
    },
    deleteOutbound (outbound) {
      this.$confirm(`确认删除出库【${outbound.code}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('outbound/delete', outbound.id).then(() => {
          this.$message.success('删除成功!')
        })
      }).catch(() => {
      })
    },
    exportData () {
      window.location.href = this.exportUrl
    }
  },
  computed: {
    outboundList () {
      let list = this.$store.state.outbound.outboundList

      if (this.filter.searchText) {
        list = list.filter(outbound => {
          if (outbound.code && outbound.code.indexOf(this.filter.searchText) !== -1) return true
          for (const goods of outbound.goodsList) {
            if (goods.name && goods.name.indexOf(this.filter.searchText) !== -1) return true
            if (goods.supplierCode &&
              valueName(goods.supplierCode, 'SUPPLIER').indexOf(this.filter.searchText) !== -1) return true
          }
          return false
        })
      }

      if (this.filter.warehouse[0]) {
        list = list.filter(outbound => {
          return outbound.warehouseId === this.filter.warehouse[0] && outbound.warehousePosId === this.filter.warehouse[1]
        })
      }

      if (this.filter.begDate !== null) {
        list = list.filter(outbound => {
          return this.filter.begDate.format('yyyy-MM-dd') <= outbound.outDate
        })
      }

      if (this.filter.endDate !== null) {
        list = list.filter(outbound => {
          return this.filter.endDate.format('yyyy-MM-dd') >= outbound.outDate
        })
      }

      return list
    },
    tableHeight () {
      return this.clientHeight - 224
    },
    readOnly () {
      return !this.$hasPermission(authority.NEILING)
    },
    addable () {
      return this.$hasPermission(authority.NEILING)
    },
    deletable () {
      return this.$hasPermission(authority.NEILING)
    },
    exportUrl () {
      const filter = this.$_.cloneDeep(this.filter)
      if (filter.begDate) {
        filter.begDate = filter.begDate.formatDate()
      }
      if (filter.endDate) {
        filter.endDate = filter.endDate.formatDate()
      }

      return this.$baseUrl + 'api/downloadOutboundList?filterStr=' + encodeURIComponent(JSON.stringify(filter))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
